// extracted by mini-css-extract-plugin
export default {"fs":"f66e9845a8 _67ee31ed5f"};